import React, { Fragment, RefObject, FC } from 'react'

import { Partner } from 'common/api/types'
import { ContactType } from 'common/interfaces'
import { LoggedInUser } from 'common/user-context'

import { ChancelleryLocationsQuery } from '../interfaces/schemaDefinition'

import { CallbackEmailRequestsView } from './CallbackEmailRequestsView'
import { RedirectRequests } from './RedirectRequestsView'

import './LawyerListView.scss'

interface OpenRequestsProps {
  onRowClick: (rowId: string) => React.EventHandler<React.FormEvent<HTMLTableRowElement>>
  chancelleryLocations: ChancelleryLocationsQuery['chancelleryLocations']['list']
  assignableUsers: Array<{ id: string; name: string }>
  assignFilter?: string
  user?: LoggedInUser
  partners: Array<Partner>
  node: RefObject<HTMLDivElement>
  addedAdviceRequest: Array<{ id: string; contactType: ContactType }>
  hasPremium: boolean
}

export const OpenRequests: FC<OpenRequestsProps> = ({
  user,
  partners,
  chancelleryLocations,
  assignableUsers,
  assignFilter,
  onRowClick,
  node,
  addedAdviceRequest,
  hasPremium,
}) => (
  <Fragment>
    <RedirectRequests
      hasPremium={hasPremium}
      user={user}
      onRowClick={onRowClick}
      partners={partners}
      chancelleryLocations={chancelleryLocations}
      assignableUsers={assignableUsers}
      assignFilter={assignFilter}
      addedAdviceRequestIds={addedAdviceRequest
        .filter(({ contactType }) => contactType === ContactType.Redirect)
        .map(({ id }) => id)}
    />
    <CallbackEmailRequestsView
      hasPremium={hasPremium}
      user={user}
      onRowClick={onRowClick}
      partners={partners}
      chancelleryLocations={chancelleryLocations}
      assignableUsers={assignableUsers}
      node={node}
      assignFilter={assignFilter}
      addedAdviceRequestIds={addedAdviceRequest
        .filter(({ contactType }) => contactType === ContactType.Callback)
        .map(({ id }) => id)}
    />
  </Fragment>
)
